function init() {

    // position mega menu dropdowns relative to window
    jQuery(window).on('load resize', function() {
        jQuery('.o-menu__subnav-mega').each(function() {

            let elem = jQuery(this).closest('.menu-item-has-children');
            let rect = elem[0].getBoundingClientRect();
            
            jQuery(this).css('left', '-' + rect.left + 'px');
            jQuery(this).css('opacity', 1);
        });
    })
}

export { init as default } 